import React, { ChangeEventHandler } from 'react';
import { Button, Collapse, InputAdornment, OutlinedInput } from '@mui/material';
import { inputAdornment, inputStyle, outlinedInput, startAdornment, btnSearch } from './SearchInput.sx';
import SearchIcon from 'app/components/Icons/SearchIcon';
import CloseIcon from 'app/components/Icons/CloseIcon';
import useSearchInput from 'app/components/SearchInput/useSearchInput';

interface Props {
  small?: boolean;
  placeholder?: string;
  width?: string;
  value: string;
  onChange: (value: string) => void;
}

const SearchInput = (props: Props) => {
  const { searchInput, setSearchInput, wrapperRef } = useSearchInput();

  const { placeholder, width, value, onChange } = props;

  return (
    <Button
      color={'secondary'}
      sx={btnSearch(true, true)}
      onClick={() => {
        if (searchInput === false) {
          setSearchInput(true);
        }
      }}
      ref={wrapperRef}
    >
      <SearchIcon />
      <OutlinedInput
        sx={{ ...outlinedInput, width: width ? width : '204px' }}
        inputProps={{
          style: inputStyle,
        }}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        endAdornment={
          value.length > 0 && (
            <InputAdornment position="end" sx={inputAdornment} onClick={() => onChange('')}>
              <CloseIcon />
            </InputAdornment>
          )
        }
        placeholder={placeholder}
      />
    </Button>
  );
};

export default SearchInput;
